// PageShell — standard page container.
//
// Centers page content on wide monitors and applies the canonical max-width
// + responsive padding + vertical rhythm. Many pages historically used
// `max-w-7xl` WITHOUT `mx-auto`, which jammed content against the left edge
// on wide displays. This component is the single source of truth for that
// layout so the centering can never drift again.
//
// Usage:
//   <PageShell>
//     <PageHeader title="…" />
//     …
//   </PageShell>

import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

interface PageShellProps {
  children: ReactNode;
  /** Override the default max-width (e.g. "max-w-5xl" for narrow pages). */
  maxWidth?: string;
  /** Extra classes appended to the container. */
  className?: string;
}

export default function PageShell({
  children,
  maxWidth = "max-w-7xl",
  className,
}: PageShellProps) {
  return (
    <div
      className={cn("p-4 md:p-6 lg:p-8 mx-auto space-y-6", maxWidth, className)}
    >
      {children}
    </div>
  );
}
